import { capitalizeFirstLetter } from 'src/utils/string';

import Button from 'src/componentes/button';
import TourController from '../TourController/TourController';

function ProactiveTourBox({
  intl,
  title,
  description,
  onSeeLater,
  onClose,
  onCloseTour,
  setOpenHelp,
  steps,
  path,
  tourName,
}) {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 40,
        right: 40,
        zIndex: 100,
        border: '1px solid #1d7789',
        borderRadius: 8,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        padding: 24,
        minWidth: 330,
        maxWidth: 410,
        color: '#f8f9fa',
        backgroundColor: '#1d7789',
        borderColor: '#1d7789',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: '#f8f9fa',
        }}
      >
        <p style={{ margin: 0, color: '#f8f9fa', fontWeight: 'bold', fontSize: 15 }}>{title}</p>
        <Button
          close
          onClick={onClose}
          className="tw:text-white tw:hover:bg-white/10 tw:hover:text-white"
          aria-label="Fechar"
        />
      </div>
      <div style={{ margin: '16px 0 24px 0', color: '#f8f9fa' }}>
        {description}
      </div>
      <div style={{ display: 'flex', gap: 14 }}>
        <TourController
          setOpenHelp={setOpenHelp}
          redirectPath={path}
          steps={steps}
          tourName={tourName}
          onClose={onCloseTour}
          ehProactiveTour={true}
        />
        <Button color="primary" onClick={onSeeLater}>
          {capitalizeFirstLetter(intl.formatMessage({ id: 'verMaisTarde' }))}
        </Button>
      </div>
    </div>
  );
}

export default ProactiveTourBox;
